import { Injectable, Signal, signal, WritableSignal } from '@angular/core';
import { filter } from 'rxjs';
import { PageKey } from './models/page.key';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { Title } from '@angular/platform-browser';

@Injectable({
  providedIn: 'root'
})
export class PageService {

  constructor(
    title: Title,
    router: Router,
    route: ActivatedRoute,
  ) {
    router.events
      .pipe(filter(event => event instanceof NavigationEnd))
      .subscribe(() => {
        let mainRoute = route.root.children[0].snapshot.data;

        let activeRoute = this.getActiveRoute(route);
        let currentRouteData = activeRoute.snapshot.data;

        this._page.set(currentRouteData['key'] || mainRoute['key'] || null);

        title.setTitle(mainRoute['title'] + ' | Plataforma');
      });
  }

  private readonly _page: WritableSignal<PageKey | null> = signal(null);

  public get page(): Signal<PageKey | null> {
    return this._page;
  }

  public set page(page: PageKey) {
    this._page.set(page);
  }

  private getActiveRoute(route: ActivatedRoute): ActivatedRoute {
    while (route.firstChild)
      route = route.firstChild;

    return route;
  }

}
